export default __webpack_public_path__ + "b77861532193a55302bd1e0abd74d92b.png";